import { CapoPlugin } from "/var/www/homedelimercado.com/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];